import {Inventory, RightsInventoryBuffer} from '@entities/rights/rights.interfaces';
import {API_DATE_FORMAT, DATE_FORMAT} from '@shared/constants/formats.constants';
import moment from 'moment';

/**
 * 'PinnedDataHelper' class definition.
 */
export class PinnedDataHelper {
	/**
	 * Prepare pinned.
	 * @param {RightsInventoryBuffer} pinned
	 * @param {string[]} pinnedXLSSelection
	 * @returns {Record<string, Inventory[]>}
	 */
	public static preparePinned(
		pinned: RightsInventoryBuffer,
		pinnedXLSSelection: string[]
	): Record<string, Inventory[]> {
		const pinnedSelected: RightsInventoryBuffer = new Map();
		pinned.forEach((values, key) => {
			if (pinnedXLSSelection.includes(key)) {
				pinnedSelected.set(key, PinnedDataHelper.transformInventoryValues(values));
			}
		});

		return Object.fromEntries(pinnedSelected);
	}

	/**
	 * Transform inventory values.
	 * @param {Inventory[]} values
	 * @returns {Inventory[]}
	 */
	private static transformInventoryValues(values: Inventory[]): Inventory[] {
		return values.map(PinnedDataHelper.transformInventoryValue) as Inventory[];
	}

	/**
	 * Transform inventory value.
	 * @param {Inventory} data
	 * @returns {Partial<Inventory>}
	 */
	private static transformInventoryValue(data: Inventory): Partial<Inventory> {
		const value = {...data};

		delete value.id;
		delete value.uniqueId;

		value.dateStart = moment(value.dateStart, DATE_FORMAT).format(API_DATE_FORMAT);
		value.dateEnd = moment(value.dateEnd, DATE_FORMAT).format(API_DATE_FORMAT);

		return value;
	}
}
